<template>
  <modal-card ref="modal">
    <h2 class="title is-4">Password Reset</h2>
    <h6 class="subtitle is-6">send password reset link to {{trainer ? trainer.email:""}}?</h6>
    <hr>
    <div class="columns">
      <div class="column">
        <div class="buttons">
        <button class="button  is-outlined" type="button" @click="closeModel()">Cancel</button>
        <button class="button is-primary is-outlined  " @click="handleResetPassword()">
          Confirm
        </button>
      </div>
      </div>
    </div>
  </modal-card>
</template>

<script>

import ModalCard from '../ModalCard.vue'
export default {
  name: 'ResetPasswordModal',
  components: {
    ModalCard
  },
  data () {
    return { }
  },
  props: {
    trainer: Object
  },
  methods: {
    handleResetPassword () {
      // reset password code
    },
    closeModel () {
      this.$refs.modal.close()
    }
  }
}
</script>
